// file: DropdownPortal.jsx
import { createPortal } from 'react-dom';

export default function DropdownPortal({ children }) {
  // By default, render in document.body
  return createPortal(children, document.body);
}
